module.exports = __webpack_public_path__ + "img/block-768.1ac8928e.jpg";